import {clsx} from 'clsx'

import type {MemexWorkflow} from '../../api/workflows/contracts'
import {useAutomationGraph} from '../../state-providers/workflows/use-automation-graph'
import styles from './connector.module.css'

interface ConnectorEndProps {
  endpointPosition: 'top' | 'bottom'
  workflow: MemexWorkflow
}

const ConnectorEndpoint = ({endpointPosition, workflow}: ConnectorEndProps) => {
  return (
    <div
      className={clsx(
        styles.connectorEndpoint,
        workflow.enabled && styles.connectorEndpointEnabled,
        endpointPosition === 'top' ? styles.connectorEndpointTop : styles.connectorEndpointBottom,
      )}
    />
  )
}

export const Connector = () => {
  const {workflow} = useAutomationGraph()
  return (
    <>
      <ConnectorEndpoint workflow={workflow} endpointPosition="top" />
      <div className={clsx(styles.connectorLine, workflow.enabled && styles.connectorLineEnabled)} />
      <ConnectorEndpoint workflow={workflow} endpointPosition="bottom" />
    </>
  )
}

try{ ConnectorEndpoint.displayName ||= 'ConnectorEndpoint' } catch {}
try{ Connector.displayName ||= 'Connector' } catch {}